/*
 * The Name step of the Tour Wizard
 */

import React, { Component, Fragment } from 'react';
import MS from 'stores/anyguide/model';
import AppStore from 'stores/anyguide/app';
import CS from 'stores/anyguide/collection';
import { Input } from 'views/anyguide/layout/form';
import { AccessibleCheckbox, green, round } from 'ui_system/inputs/checkboxes';
import {
  RadioGroup,
  RadioGroupContainer,
  grid2wide,
} from 'ui_system/inputs/radio_group';
import styled from '@emotion/styled';
import { Theme } from 'ui_system/theme';

const NameInput = styled('input')`
  font-size: 17px;
  border: 1px solid ${Theme.colors.borderActionableFieldColor};
  color: ${Theme.colors.primaryTextColor};
  padding: 10px;
  text-align: left;
  display: block;
  width: 100%;
  -webkit-appearance: none;
  border-radius: 0;
  &::placeholder {
    color: ${Theme.colors.guideTextColor};
  }
`;
export class TourName extends Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange = (name) => (e) => {
    const { onChangeCallback } = this.props;
    onChangeCallback(name, e.target.value);
  };

  render() {
    const { name } = this.props.savedValues;
    return (
      <div className="TourWizard TourWizard-Name">
        <div className="TourWizard-Input">
          <NameInput
            value={name}
            data-testid="input-name"
            onChange={this.handleOnChange('name')}
            maxlength="75"
            placeholder="Enter a name"
          />
          <div className="TourWizard-Input-limit">75 Character limit</div>
        </div>
      </div>
    );
  }
}
